export default __webpack_public_path__ + "static/remote-bombs-b98209d7936b759460c5ed84ca1c2f50.png";